import Vue from "vue";
import Vuetify from "vuetify/lib";
// Fonts
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { colors } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      global: "mdi-earth",
      add: "mdi-plus",
      submit: "mdi-check",
      cancel: "mdi-close-thick",
      back: "mdi-chevron-left",
      next: "mdi-chevron-right",
      update: "mdi-pencil",
      view: "mdi-eye",
      newTab: "mdi-open-in-new",
      search: "mdi-magnify",
      query: "mdi-cloud-search",
      filter: "mdi-filter-multiple",
      undo: "mdi-undo",
      review: "mdi-help-circle",
      lock: "mdi-lock-open",
      file: "mdi-file-document",
      fileNew: "mdi-file-document-plus",
      fileNewOutline: "mdi-file-document-plus-outline",
      emailTemplates: "mdi-email-newsletter",
      email: "mdi-email",
      phoneNumber: "mdi-phone",
      contact: "mdi-badge-account-horizontal",
      contacts: "mdi-contacts",
      money: "mdi-cash",
      ledger: "mdi-calendar-text",
      country: "mdi-earth",
      state: "mdi-map-marker",
      tasks: "mdi-file-tree",
      task: "mdi-calendar-check",
      users: "mdi-account-group",
      user: "mdi-account",
      vendors: "mdi-package-variant-closed-check",
      retailBrand: "mdi-store",
      vendorOrder: "mdi-truck",
      components: "mdi-puzzle",
      workOrder: "mdi-beaker",
      order: "mdi-clipboard-list",
      orderNew: "mdi-clipboard-plus",
      onboarding: "mdi-timeline-check",
      leadPool: "mdi-account-search",
      parentAccount: "mdi-domain",
      account: "mdi-folder-account",
      childAccount: "mdi-account-child",
      whiteLabel: "mdi-package",
      location: "mdi-warehouse",
      eventStaffing: "mdi-briefcase-account",
      storeEvent: "mdi-calendar-multiple",
      mixCalculator: "mdi-tune-vertical",
      rawMaterial: "mdi-cannabis",
      rawMaterialVendor: "mdi-power-plug",
      terpene: "mdi-water",
      budtenderTraining: "mdi-school",
      promotion: "mdi-sale",
      supportTicket: "mdi-briefcase",
      testingLab: "mdi-test-tube",
      transfer: "mdi-transfer",
      shipping: "mdi-package-variant-closed",
      productCategory: "mdi-sitemap",
      products: "mdi-package-variant",
      productLot: "mdi-tag-text",
      ar: "mdi-hand-coin",
      map: "mdi-map-marker-radius",
      email: "mdi-email",
      expenseTypes: "mdi-file-sign",
      expenseVendors: "mdi-card-account-details",
      expenses: "mdi-account-cash",
      projects: "mdi-chart-gantt",
      projectTemplates: "mdi-format-list-group-plus",
      cursor: "mdi-cursor-default",
      notification: "mdi-bell",
      notificationNew: "mdi-bell-plus",
      actionList: "mdi-list-status",
      socials: "mdi-account-voice",
      alerts: "mdi-timer",
      alertNew: "mdi-timer-plus",
      room: "mdi-floor-plan",
      plant: "mdi-tree",
      qrTemplates: "mdi-qrcode",
      reminderNew: "mdi-timer-plus",
      reminder: "mdi-timer-alert",
      reminders: "mdi-timer-alert",
    },
  },
  theme: {
    defaultTheme: "dark",
    options: { customProperties: true },
    themes: {
      light: {
        primary: colors.shades.black,
        secondary: colors.shades.white,
        bg: colors.grey.lighten4,
        background: colors.grey.lighten4,
        background: colors.grey.lighten4,
        background2: colors.grey.lighten3,
        background3: colors.grey.lighten2,
        background4: colors.grey.lighten1,
        background5: colors.grey.base,
        background6: colors.grey.darken1,
        secondaryBackground: colors.shades.white,
        secondarySheet: colors.grey.lighten4,
        icon: colors.grey.darken3,
        secondaryIcon: colors.grey.darken1,
        review: colors.blue.base,
        border: colors.grey.lighten2,
        secondaryBorder: colors.grey.base,
        loading: colors.grey.darken2,
        sample: colors.blue.lighten2,

        information: colors.blue.lighten1,
        paused: colors.deepPurple.base,
        success: colors.green.base,
        error: colors.red.base,
        update: colors.orange.base,
        contacts: colors.deepPurple.base,
        money: colors.green.darken3,
        shipping: colors.purple.base,
        orders: colors.orange.darken2,
        products: colors.brown.base,
        ledger: colors.grey.lighten1,
        promotion: colors.teal.base,
        promoUnit: colors.lightBlue.darken3,
        overpaymentCredit: colors.blueGrey.base,
        productLot: colors.indigo.darken4,
        navBar: colors.shades.black,
        promoText: "#9421d1",
        promoBackground: "#D320FF",
        colors,
        required: colors.yellow.lighten3,
        optional: colors.grey.lighten4,
        updated: colors.orange.lighten3,
        greyText: "#444746",
        gradient: `linear-gradient(to right, #0f2027, #203a43, #2c5364)`,
      },
      dark: {
        primary: colors.shades.white,
        secondary: colors.shades.black,
        bg: "#121212",
        background: "#121212",
        background2: "#282828",
        background3: "#3f3f3f",
        background4: "#575757",
        background5: "#717171",
        background6: "#b6b6b6",
        secondaryBackground: "#1e1e1e",
        secondarySheet: "#272727",
        icon: colors.grey.lighten4,
        secondaryIcon: colors.grey.lighten2,
        review: colors.lightBlue.lighten1,
        border: "#565656",
        secondaryBorder: colors.grey.darken2,
        loading: colors.grey.base,
        sample: colors.blue.lighten2,
        information: colors.blue.lighten2,
        paused: colors.deepPurple.base,
        success: colors.green.base,
        error: colors.red.accent2,
        update: colors.orange.lighten1,
        contacts: colors.deepPurple.base,
        money: colors.green.darken3,
        shipping: colors.purple.base,
        orders: colors.orange.darken2,
        products: colors.brown.lighten2,
        ledger: colors.grey.base,
        promotion: colors.teal.lighten2,
        promoUnit: colors.lightBlue.darken3,
        overpaymentCredit: colors.blueGrey.base,
        productLot: colors.indigo.darken4,
        navBar: colors.grey.darken4,
        promoText: "#D99AFC",
        promoBackground: "#D320FF",
        colors,
        required: colors.yellow.darken3,
        optional: colors.grey.darken2,
        updated: colors.orange.darken3,
        greyText: "#C4C7C5",
        gradient: `linear-gradient(159deg, rgba(0,0,128,1) 0%, rgba(0,191,255,1) 100%)`,
      },
    },
  },
});
